import { render, staticRenderFns } from "./ResourceTree.vue?vue&type=template&id=25dec6e0&scoped=true&"
import script from "./ResourceTree.vue?vue&type=script&lang=js&"
export * from "./ResourceTree.vue?vue&type=script&lang=js&"
import style0 from "./ResourceTree.vue?vue&type=style&index=0&id=25dec6e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dec6e0",
  null
  
)

export default component.exports